import { DISMISSED_APP_ALERT_COOKIE_KEY } from "@/constants";
import type { AppAlertContent } from "@/types/cms";

/**
 * Dismissal is stored in a cookie rather than sessionStorage so the root
 * layout can read it during SSR and skip rendering a dismissed alert, instead
 * of rendering it and hiding it after hydration.
 *
 * Only the latest dismissed revision is kept; there is at most one active
 * alert at a time.
 */

// Keyed by revision so editing an alert in Strapi re-shows it.
export const getAppAlertRevision = ({
	id,
	version,
}: Pick<AppAlertContent, "id" | "version">): string => `${id}-${version}`;

/** No max-age: a session cookie, cleared when the browser closes. */
export const writeDismissedAppAlert = (
	alert: Pick<AppAlertContent, "id" | "version">
): void => {
	if (typeof document === "undefined") return;
	document.cookie = `${DISMISSED_APP_ALERT_COOKIE_KEY}=${encodeURIComponent(getAppAlertRevision(alert))}; path=/; SameSite=Lax`;
};
